import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {MatStepperModule} from '@angular/material/stepper';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {LetModule, PushModule} from '@ngrx/component';
import {
  CheckoutWaitDialogModule,
  StripeErrorModalModule,
  UpdateSubscriptionErrorModule,
  UpdateSubscriptionSuccessModule
} from '@spout/global-web/data-access';
import {
  DownloadSpoutModule,
  LoginModule,
  SptMySubscriptionModule,
  SubscriptionEndModule
} from '@spout/global-web/ui';
import {AddonStorageModuleModule} from '../common/addon-storage-module/addon-storage-module.module';
import {EarlyAdopterModalModule} from '../common/early-adopter-modal/early-adopter-modal.module';
import {PaymentWizardSmallComponent} from './payment-wizard-small.component';
import {PricingSmallModule} from './pricing-small/pricing-small.module';

@NgModule({
  declarations: [PaymentWizardSmallComponent],
  exports: [PaymentWizardSmallComponent],
  imports: [
    CommonModule,
    UpdateSubscriptionErrorModule,
    UpdateSubscriptionSuccessModule,
    CheckoutWaitDialogModule,
    PricingSmallModule,
    LetModule,
    PushModule,
    ReactiveFormsModule,
    EarlyAdopterModalModule,
    StripeErrorModalModule,
    DownloadSpoutModule,

    SptMySubscriptionModule,
    SubscriptionEndModule,

    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatRadioModule,
    MatStepperModule,
    MatTableModule,
    LoginModule,
    AddonStorageModuleModule
  ]
})
export class PaymentWizardSmallModule {}
